import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Message } from 'primeng/api';
import { Chart } from 'chart.js';


@Component({
  selector: 'app-audiometry-table',
  templateUrl: './audiometry-table.component.html',
  styleUrls: ['./audiometry-table.component.scss']
})
export class AudiometryTableComponent implements OnInit, OnDestroy {
  @ViewChild('mychart', {static: true}) chartElement: ElementRef;
  chart: Chart;
  @Output() newTableItem = new EventEmitter<any>();
  @Output() isValid: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() airWay: any;
  @Input() airWayOi: any;
  @Input() viaBone: any;
  @Input() viaBoneOi: any;
  @Input() submitted: boolean;
  messagesErrorPrevious: Message[];

  suma: any[] = [];
  odGraphics: any;
  oiGraphics: any;
  viaGraphics: any;
  viaOiGraphics: any;
  imageBase64="";
  chartData: any;
  invalid: boolean;
  isMaxValue: boolean;
  nameValue: string;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
  }

  async ngAfterViewInit() {
    await this.seeGraphic();
    this.cdr.detectChanges();
    setTimeout(() => {
      this.seeGraphic();
    }, 100);
  }

  sumFrecuency() {
    this.suma = [this.airWay[0].od125, this.airWay[0].od250 , this.airWay[0].od500 , this.airWay[0].od1000 ,
    this.airWay[0].od2000 , this.airWay[0].od4000 , this.airWay[0].od6000 , this.airWay[0].od8000];
    let total=0;
    for (let i = 0; i < this.suma.length; i++) {
    if (!isNaN(this.suma[i])){total+=this.suma[i];}}
    this.airWay[0].odSuma = total;
  }

  sumFrecuencyOi() {
    const suma = [this.airWayOi[0].oi125 , this.airWayOi[0].oi250 , this.airWayOi[0].oi500 , this.airWayOi[0].oi1000 ,
    this.airWayOi[0].oi2000 , this.airWayOi[0].oi4000 , this.airWayOi[0].oi6000 , this.airWayOi[0].oi8000];
    let total=0;
    for (let i = 0; i < suma.length; i++) {
    if (!isNaN(suma[i])) {total+=suma[i];}}
    this.airWayOi[0].oiSuma = total;
  }

   onClearViaOseaOd(event:any) {
    if (event==null) {
      this.airWayOi[0].oi6000 = null;
      this.viaBone[0].oseaod6000 = null;
      this.viaBoneOi[0].oseaoi6000 = null;
      setTimeout(() => {
        if (isNaN(this.viaBone[0].oseaod6000)) {
          this.airWayOi[0].oi6000 = null;
          this.viaBone[0].oseaod6000 = null;
          this.viaBoneOi[0].oseaoi6000 = null;
        }
      }, 7);
    }
    this.addTechItem();
    this.seeGraphic();
  }

  onClearViaOseaOi(event:any) {
    if (event==null) {
      this.viaBoneOi[0].oseaoi6000 = null;
      setTimeout(() => {
        if (this.viaBoneOi[0].oseaoi6000) {
          this.viaBoneOi[0].oseaoi6000 = null;
        }
      }, 7);
    }
    this.addTechItem();
    this.seeGraphic();
  }

  async addTechItem() {
    this.seeGraphic();
    let tableAudiometria: any = {
      od125: this.airWay[0].od125,
      od250: this.airWay[0].od250,
      od500: this.airWay[0].od500,
      od1000: this.airWay[0].od1000,
      od2000: this.airWay[0].od2000,
      od4000: this.airWay[0].od4000,
      od6000: this.airWay[0].od6000,
      od8000: this.airWay[0].od8000,
      odSuma: this.airWay[0].odSuma,
      odPab: this.airWay[0].odPab,
      odTo: this.airWay[0].odTo,
      oi125: this.airWayOi[0].oi125,
      oi250: this.airWayOi[0].oi250,
      oi500: this.airWayOi[0].oi500,
      oi1000: this.airWayOi[0].oi1000,
      oi2000: this.airWayOi[0].oi2000,
      oi4000: this.airWayOi[0].oi4000,
      oi6000: this.airWayOi[0].oi6000,
      oi8000: this.airWayOi[0].oi8000,
      oiSuma: this.airWayOi[0].oiSuma,
      oiPab: this.airWayOi[0].oiPab,
      oiTo: this.airWayOi[0].oiTo,
      oseaod250: this.viaBone[0].oseaod250,
      oseaod500: this.viaBone[0].oseaod500,
      oseaod1000: this.viaBone[0].oseaod1000,
      oseaod2000: this.viaBone[0].oseaod2000,
      oseaod4000: this.viaBone[0].oseaod4000,
      oseaod6000: this.viaBone[0].oseaod6000,
      oseaoi250: this.viaBoneOi[0].oseaoi250,
      oseaoi500: this.viaBoneOi[0].oseaoi500,
      oseaoi1000: this.viaBoneOi[0].oseaoi1000,
      oseaoi2000: this.viaBoneOi[0].oseaoi2000,
      oseaoi4000: this.viaBoneOi[0].oseaoi4000,
      oseaoi6000: this.viaBoneOi[0].oseaoi6000,
      imgGraficoAudiometria: this.imageBase64.split(",")[1].trim(),
    }
    let valid = this.validateFieldsTables(tableAudiometria);
    this.isValid.emit(valid);
    await this.newTableItem.emit(tableAudiometria);
  }

generateSvgDataUri(svgContent: string): string {
  return 'data:image/svg+xml;base64,' + btoa(svgContent);
}

// GENERACIÓN DEL GRÁFICO DE AUDIOMETRÍA
async seeGraphic(): Promise<void> {
    let labelXCorden: any[] = [];
      if (this.airWay[0].od6000 || this.airWayOi[0].oi6000 || this.viaBone[0].oseaod6000 || this.viaBoneOi[0].oseaoi6000) {
      labelXCorden = ['125', '250', '500','1000','2000', '4000', '6000','8000'];
    } else {
      labelXCorden = ['125', '250', '500','1000','2000', '4000','8000'];
    }

    const ctx = this.chartElement.nativeElement.getContext('2d');

    this.destroyChart();

    const svgDataUriBlue = this.generateSvgDataUri(`
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 24"><g data-name="Next_icon"><path d="M0 0h24v24H0z" style="fill:none" transform="translate(16)"/><path d="M7.58 20.83a1 1 0 0 1 0-1.41L15 12 7.58 4.58a1 1 0 0 1 0-1.41 1 1 0 0 1 1.42 0l8.48 8.48a.51.51 0 0 1 0 .71L9 20.83a1 1 0 0 1-1.42 0z" style="fill:#2196f3" transform="translate(16)"/></g></svg>
    `);

    const svgDataUriRed = this.generateSvgDataUri(`
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 24"><g data-name="Back_icon"><path d="m15 20.83-8.48-8.48a.51.51 0 0 1 0-.71L15 3.17a1 1 0 0 1 1.41 0 1 1 0 0 1 0 1.41L9 12l7.42 7.42a1 1 0 0 1 0 1.41 1 1 0 0 1-1.42 0z" style="fill:#ff5152" transform="translate(-8)"/><path d="M0 0h24v24H0z" style="fill:none" transform="translate(-8)"/></g></svg>
    `);

  this.destroyChart();

    this.chartData = {
      labels: labelXCorden,
      datasets: [
        {
          label: '#Vía aérea oído derecho',
          data: this.airWay[0].od6000 ? [this.airWay[0].od125, this.airWay[0].od250, this.airWay[0].od500, this.airWay[0].od1000,
          this.airWay[0].od2000, this.airWay[0].od4000, this.airWay[0].od6000, this.airWay[0].od8000] : [this.airWay[0].od125,
          this.airWay[0].od250, this.airWay[0].od500, this.airWay[0].od1000, this.airWay[0].od2000, this.airWay[0].od4000, this.airWay[0].od8000],
          borderColor: "rgba(255, 99, 132, 1)",
          borderWidth: 3,
          fill: false,
          backgroundColor: "rgba(255, 99, 132, 0.4)",
          pointRadius: 10,
          pointHoverRadius: 12,
          tension: 0,
          borderDash: [6,6],
          pointStyle: 'circle',
          pointBackgroundColor:'transparent'
        },
        {
          label: '#Vía aérea oído izquierdo',
          data:this.airWayOi[0].oi6000 ? [this.airWayOi[0].oi125, this.airWayOi[0].oi250, this.airWayOi[0].oi500, this.airWayOi[0].oi1000,
          this.airWayOi[0].oi2000, this.airWayOi[0].oi4000, this.airWayOi[0].oi6000, this.airWayOi[0].oi8000] : [this.airWayOi[0].oi125, this.airWayOi[0].oi250, this.airWayOi[0].oi500, this.airWayOi[0].oi1000,
          this.airWayOi[0].oi2000, this.airWayOi[0].oi4000, this.airWayOi[0].oi8000],
          borderColor: "rgba(54, 162, 235, 1)",
          borderWidth: 3,
          fill: false,
          backgroundColor: "rgba(99, 138, 255, 0.4)",
          pointRadius: 10,
          pointHoverRadius: 12,
          tension: 0,
          borderDash: [6,6],
          pointStyle: 'crossRot',

        },
        {
          label: '#Vía ósea oído derecho',
          data:this.viaBone[0].oseaod6000 ? [null,this.viaBone[0].oseaod250, this.viaBone[0].oseaod500, this.viaBone[0].oseaod1000,
          this.viaBone[0].oseaod2000, this.viaBone[0].oseaod4000, this.viaBone[0].oseaod6000] : [null,this.viaBone[0].oseaod250, this.viaBone[0].oseaod500, this.viaBone[0].oseaod1000,
          this.viaBone[0].oseaod2000, this.viaBone[0].oseaod4000],
          borderColor: "#FF5152",
          fill: false,
          pointStyle: function(context){
            var img = new Image(35, 30);
            img.src = svgDataUriRed;
            return img;
          },
          borderWidth: 'transparent',
          pointRadius: 8,
          pointHoverRadius: 10
        },
        {
          label: '#Vía ósea oído izquierdo',
          data: this.viaBoneOi[0].oseaoi6000 ? [null,this.viaBoneOi[0].oseaoi250, this.viaBoneOi[0].oseaoi500, this.viaBoneOi[0].oseaoi1000,
          this.viaBoneOi[0].oseaoi2000, this.viaBoneOi[0].oseaoi4000, this.viaBoneOi[0].oseaoi6000] : [null,this.viaBoneOi[0].oseaoi250, this.viaBoneOi[0].oseaoi500, this.viaBoneOi[0].oseaoi1000,
          this.viaBoneOi[0].oseaoi2000, this.viaBoneOi[0].oseaoi4000],
          borderColor: "#2196F3",
          fill: false,
          pointStyle: function(context){
            var img = new Image(35, 30);
            img.src = svgDataUriBlue;
            return img;
          },
          borderWidth: 'transparent',
          pointRadius: 8,
          pointHoverRadius: 10

        }
    ]};

    if (this.chart) {
      // Si el gráfico ya existe, actualiza los datos
      this.chart.data = this.chartData;
    } else {
      this.chart = new Chart(ctx, {
        type: 'line',
        data: this.chartData,
        options: {
            scales: {
                yAxes: [{
                    ticks: {
                        //beginAtZero: true,
                        reverse: true,
                        suggestedMin: 0,
                        suggestedMax: 120,
                        stepSize: 10
                    }
                }],
            },
            bezierCurve : false,
            animation : false,
            //{
              //onComplete : function(){
                //console.log(this.toBase64Image());
              //}
            hover: {
              enabled: false,
              animationDuration: 0,
              mode:null
            },
            responsive: true,
            elements: {
              line: {
                tension: 0 // disables bezier curves
              }
            }
        }
    });
    }
    this.imageBase64 = this.chart.toBase64Image();
    await this.chart.update();
  }

  ngOnDestroy() {
    this.destroyChart();
  }

  destroyChart() {
    if (this.chart){
      this.chart.destroy();
      this.chart = null;
    }
  }

  updateValueAreaOd(field: string, value1: number, value2: number) {
    const fieldValue = `od${field}`;
    const fieldValue2 = `oseaod${field}`;

    if (value1 > 120) {
      this.airWay[0][fieldValue] = null;
      this.isMaxValue = true;
      this.nameValue = fieldValue;
      return;
    }

    if (value1 && value2) {
      if (value1 < value2) {
        this.invalid = true;
        this.viaBone[0][fieldValue2] = null;

        this.messagesErrorPrevious = [{
          severity: 'error',
          summary: 'Error',
          detail: 'El valor de frecuencia en la vía ósea no puede ser mayor al valor registrado en la vía aérea'
        }];

        setTimeout(() => {
          this.messagesErrorPrevious = [];
        }, 10000);
      } else {
        this.viaBone[0][fieldValue2] = value2;
      }
    }
    this.seeGraphic();
  }

  updateValueAreaOi(field: string, value1: number, value2: number) {
    const fieldValue = `oi${field}`;
    const fieldValue2 = `oseaoi${field}`;

    if (value1 > 120) {
      this.airWayOi[0][fieldValue] = null;
      this.isMaxValue = true;
      this.nameValue = fieldValue;
      return;
    }

    if (value1 && value2) {
      if (value1 < value2) {
        this.invalid = true;
        this.viaBoneOi[0][fieldValue2] = null;

        this.messagesErrorPrevious = [{
          severity: 'error',
          summary: 'Error',
          detail: 'El valor de frecuencia en la vía ósea no puede ser mayor al valor registrado en la vía aérea'
        }];

        setTimeout(() => {
          this.messagesErrorPrevious = [];
        }, 10000);
      } else {
        this.viaBoneOi[0][fieldValue2] = value2;
      }
    }

    this.seeGraphic();
  }

  updateValueOseaOd(field: string, value1: number, value2: number) {
    const fieldValue = `oseaod${field}`;

    if (value1 > 120) {
      this.viaBone[0][fieldValue] = {};

      setTimeout(() => {
        if (isNaN(this.viaBone[0][fieldValue])) {
          this.viaBone[0][fieldValue] = null;
        }
      }, 1);
      this.isMaxValue = true;
      this.nameValue = fieldValue;
      return;
    }

    if (value1 > value2) {
      this.invalid = true;
      this.viaBone[0][fieldValue] = {};

      setTimeout(() => {
        if (isNaN(this.viaBone[0][fieldValue])) {
          this.viaBone[0][fieldValue] = null;
        }
      }, 1);

      if (this.invalid) {
        this.messagesErrorPrevious = [{
          severity: 'error',
          summary: 'Error',
          detail: 'El valor de frecuencia en la vía ósea no puede ser mayor al valor registrado en la vía aérea'
        }];

        setTimeout(() => {
          this.messagesErrorPrevious = [];
        }, 10000);
      }
    }

    if (!value2) {
      this.viaBone[0][fieldValue] = {};

      setTimeout(() => {
        if (isNaN(this.viaBone[0][fieldValue])) {
          this.viaBone[0][fieldValue] = null;
        }
      }, 1);

      this.messagesErrorPrevious = [{
        severity: 'error',
        summary: 'Error',
        detail: 'Debe cargar previamente esta frecuencia en el cuadro de vía aérea'
      }];

      setTimeout(() => {
        this.messagesErrorPrevious = [];
      }, 7000);
    }
    this.seeGraphic();
  }

  updateValueOseaOi(field: string, value1: number, value2: number) {
    const fieldValue = `oseaoi${field}`;

    if (value1 > 120) {
      this.viaBoneOi[0][fieldValue] = {};

      setTimeout(() => {
        if (isNaN(this.viaBoneOi[0][fieldValue])) {
          this.viaBoneOi[0][fieldValue] = null;
        }
      }, 1);
      this.isMaxValue = true;
      this.nameValue = fieldValue;
      return;
    }

    if (value1 > value2) {
      this.invalid = true;
      this.viaBoneOi[0][fieldValue] = {};

      setTimeout(() => {
        if (isNaN(this.viaBoneOi[0][fieldValue])) {
          this.viaBoneOi[0][fieldValue] = null;
        }
      }, 1);

      if (this.invalid) {
        this.messagesErrorPrevious = [{
          severity: 'error',
          summary: 'Error',
          detail: 'El valor de frecuencia en la vía ósea no puede ser mayor al valor registrado en la vía aérea'
        }];

        setTimeout(() => {
          this.messagesErrorPrevious = [];
        }, 10000);
      }
    }

    if (!value2) {
      this.viaBoneOi[0][fieldValue] = {};

      setTimeout(() => {
        if (isNaN(this.viaBoneOi[0][fieldValue])) {
          this.viaBoneOi[0][fieldValue] = null;
        }
      }, 1);

      this.messagesErrorPrevious = [{
        severity: 'error',
        summary: 'Error',
        detail: 'Debe cargar previamente esta frecuencia en el cuadro de vía aérea'
      }];

      setTimeout(() => {
        this.messagesErrorPrevious = [];
      }, 7000);
    }
    this.seeGraphic();
  }

  isNullOrUndefinedOrEmpty(value: any): boolean {
    return value === null || value === undefined || value === '';
  }

  validateFieldsTables(tableAudiometria:any): boolean {

    let isValid = false;
    if (
        (!this.isNullOrUndefinedOrEmpty(tableAudiometria.od125)) &&
        (!this.isNullOrUndefinedOrEmpty(tableAudiometria.od250)) &&
        (!this.isNullOrUndefinedOrEmpty(tableAudiometria.od500)) &&
        (!this.isNullOrUndefinedOrEmpty(tableAudiometria.od1000)) &&
        (!this.isNullOrUndefinedOrEmpty(tableAudiometria.od2000)) &&
        (!this.isNullOrUndefinedOrEmpty(tableAudiometria.od4000)) &&
        (!this.isNullOrUndefinedOrEmpty(tableAudiometria.od8000)) &&
        (!this.isNullOrUndefinedOrEmpty(tableAudiometria.odPab)) &&
        (!this.isNullOrUndefinedOrEmpty(tableAudiometria.odTo)) &&
        (!this.isNullOrUndefinedOrEmpty(tableAudiometria.oi125)) &&
        (!this.isNullOrUndefinedOrEmpty(tableAudiometria.oi250)) &&
        (!this.isNullOrUndefinedOrEmpty(tableAudiometria.oi500)) &&
        (!this.isNullOrUndefinedOrEmpty(tableAudiometria.oi1000)) &&
        (!this.isNullOrUndefinedOrEmpty(tableAudiometria.oi2000)) &&
        (!this.isNullOrUndefinedOrEmpty(tableAudiometria.oi4000)) &&
        (!this.isNullOrUndefinedOrEmpty(tableAudiometria.oi8000)) &&
        (!this.isNullOrUndefinedOrEmpty(tableAudiometria.oiPab)) &&
        (!this.isNullOrUndefinedOrEmpty(tableAudiometria.oiTo)) &&
        (!this.isNullOrUndefinedOrEmpty(tableAudiometria.oseaod250)) &&
        (!this.isNullOrUndefinedOrEmpty(tableAudiometria.oseaod500)) &&
        (!this.isNullOrUndefinedOrEmpty(tableAudiometria.oseaod1000)) &&
        (!this.isNullOrUndefinedOrEmpty(tableAudiometria.oseaod2000)) &&
        (!this.isNullOrUndefinedOrEmpty(tableAudiometria.oseaod4000)) &&
        (!this.isNullOrUndefinedOrEmpty(tableAudiometria.oseaoi250)) &&
        (!this.isNullOrUndefinedOrEmpty(tableAudiometria.oseaoi500)) &&
        (!this.isNullOrUndefinedOrEmpty(tableAudiometria.oseaoi1000)) &&
        (!this.isNullOrUndefinedOrEmpty(tableAudiometria.oseaoi2000)) &&
        (!this.isNullOrUndefinedOrEmpty(tableAudiometria.oseaoi4000))
        )
        isValid = true;

    if (!this.isNullOrUndefinedOrEmpty(tableAudiometria.od6000) && (this.isNullOrUndefinedOrEmpty(tableAudiometria.oi6000))) isValid = false;
    if (!this.isNullOrUndefinedOrEmpty(tableAudiometria.od6000) && (this.isNullOrUndefinedOrEmpty(tableAudiometria.oseaod6000))) isValid = false;
    if (!this.isNullOrUndefinedOrEmpty(tableAudiometria.oi6000) && (this.isNullOrUndefinedOrEmpty(tableAudiometria.oseaoi6000))) isValid = false;
    return isValid;
  }

}
